import React from 'react';
import { Link } from 'react-router-dom';
import { Plus, Trash2 } from 'lucide-react';
import { Button } from './ui/button';
import { getFullImageUrl } from '../utils/imageUrl';

export default function FavoriteProductCard({ product, onAddToCart, onRemoveFavorite }) {
    const img = getFullImageUrl(product.image_url);
    const out = (product.stock ?? 0) <= 0;

    return (
        <div className="bg-card border rounded-xl p-3 flex gap-3 items-center">
            <Link to={`/product/${product.id}`} className="shrink-0">
                <div className="w-16 h-16 rounded-lg overflow-hidden bg-muted">
                    {img ? (
                        <img src={img} alt={product.name} className="w-full h-full object-cover" />
                    ) : (
                        <div className="w-full h-full flex items-center justify-center text-xs text-muted-foreground">
                            —
                        </div>
                    )}
                </div>
            </Link>
            <div className="flex-1 min-w-0">
                <Link to={`/product/${product.id}`}>
                    <p className="font-medium text-sm truncate text-primary">{product.name}</p>
                </Link>
                <p className="text-sm font-semibold mt-0.5">€{Number(product.price).toFixed(2)}</p>
                {out && <p className="text-xs text-destructive mt-1">Εξαντλημένο</p>}
            </div>
            <div className="flex flex-col gap-1 shrink-0">
                <Button
                    type="button"
                    size="sm"
                    className="rounded-full h-9 px-3"
                    disabled={out}
                    onClick={() => onAddToCart(product)}
                >
                    <Plus className="w-4 h-4 mr-1" />
                    Στο καλάθι
                </Button>
                {onRemoveFavorite && (
                    <Button
                        type="button"
                        variant="ghost"
                        size="sm"
                        className="rounded-full h-8 text-muted-foreground"
                        onClick={() => onRemoveFavorite(product.id)}
                    >
                        <Trash2 className="w-4 h-4" />
                    </Button>
                )}
            </div>
        </div>
    );
}
